export default __webpack_public_path__ + "static/media/img-slider-ommerchant-2.1ab2c739.png";